import { type ReactNode } from 'react';

import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import AddOnIcon, { type AddOnIconProps } from 'components/standard/AddOnIcon';

export interface AddonCardProps {
	title: ReactNode;
	info?: ReactNode;
	infoContainerProps?: StackProps;
	addOnType: AddOnIconProps['type'];
}

const AddonCard = ({
	title,
	info,
	infoContainerProps,
	addOnType,
}: AddonCardProps) => {
	return (
		<Stack direction="row" gap={200}>
			<AddOnIcon type={addOnType} size="medium" />
			<Stack justifyContent="center" gap={150}>
				<Typography variant="title-xs" fontWeight={500}>
					{title}
				</Typography>
				{info && <Stack {...infoContainerProps}>{info}</Stack>}
			</Stack>
		</Stack>
	);
};

export default AddonCard;
